import TituloPrincipalH1 from '@/components/elements/TituloPrincipalH1';
import { useTranslation } from 'next-i18next';
import React, { useEffect } from 'react';
import { useServices } from '@/context/ServicesProvider';
import { AxiosResponse } from 'axios';
import { TipoClasificacion, UsuarioLogrosObj } from '@/objects/Gamificacion';
import Subtitulo from '@/components/elements/Subtitulo';
import RowRanking from '@/components/elements/listas/lista_ranking/RowRanking';
import TopNavigation from '@/components/elements/TopNavigation';
import { OpcionTopNavigation } from '@/objects/Menus';

function RankingLogros() {

    const { t } = useTranslation();
    const { gamificationQueries } = useServices();

    const [ranking, setRanking] = React.useState<UsuarioLogrosObj[]>([]);
    const [tipoClasificacion, setTipoClasificacion] = React.useState<TipoClasificacion>(TipoClasificacion.MENSUAL);

    const opcionesBarraMenuMensajes: OpcionTopNavigation[] = [
        { nombre: t("menu:secciones.ranking.fecha.mes"), tipoOpcion: TipoClasificacion.MENSUAL },
        { nombre: t("menu:secciones.ranking.fecha.semana"), tipoOpcion: TipoClasificacion.SEMANAL },
        { nombre: t("menu:secciones.ranking.fecha.anual"), tipoOpcion: TipoClasificacion.ANUAL },
        { nombre: t("menu:secciones.ranking.fecha.total"), tipoOpcion: TipoClasificacion.SIEMPRE },
    ];

    useEffect(() => {
        cargar();
    }, [tipoClasificacion]);


    function cargar() {
        gamificationQueries?.rankingUsuarios(tipoClasificacion).then((response: AxiosResponse<UsuarioLogrosObj[]>) => {
            if (response.status == 200) {
                const clasificacion: UsuarioLogrosObj[] = response.data;
                setRanking(clasificacion);
            }
        }
        ).catch((error: any) => {

        });
    }

    return (
        <section style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <TituloPrincipalH1 texto={t("menu:secciones.ranking.titulo")} />
            <Subtitulo texto={t("menu:secciones.ranking.descripcion")} />
            <TopNavigation
                opciones={opcionesBarraMenuMensajes}
                opcionActual={tipoClasificacion.toString()}
                setOpcionActual={(opcion: string) => setTipoClasificacion(opcion as TipoClasificacion)}
                style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 5,
                    flexShrink: 0,
                }}
            />
            <section style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: "100%" }}>
                {ranking.map((logro: UsuarioLogrosObj, index: number) => {
                    return <RowRanking key={index} usuarioLogrosObj={logro} posicion={index} />
                })}
            </section>
        </section>
    );
}

export default RankingLogros;